export default [
    {
        path: '/admin/purchase-request-templates',
        name: 'purchase-request-template',
        meta: { requiresAuth: true },
        component: () => import('@/pages/pr-template/index.vue')
    },
    {
        path: '/admin/purchase-request-templates/create',
        name: 'purchase-request-template-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/pr-template/create.vue')
    },
    {
        path: '/admin/purchase-request-templates/:id/edit',
        name: 'purchase-request-template-edit',
        meta: { requiresAuth: true },
        component: () => import('@/pages/pr-template/edit.vue')
    }
]
